import { PercentPipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { ConsultaVendaAcessoriosService } from './consulta-venda-acessorios.service';
import { ConsultaVendaAcessoriosResponse, ConsultaVendaAcessoriosItem } from './consulta-venda-acessorios';

declare var $: any;

@Component({
  selector: 'app-consulta-venda-acessorios',
  templateUrl: './consulta-venda-acessorios.component.html',
  styleUrls: ['./consulta-venda-acessorios.component.scss']
})
export class ConsultaVendaAcessoriosComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  cols: any[];
  _selectedColumns: any[];
  dados: ConsultaVendaAcessoriosItem[] = [];
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  carregando: boolean = false;
  displayFiltros: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  display: boolean = false;

  // Totais
  totalValorBruto: number = 0;
  totalValorDesconto: number = 0;
  totalValorComDesconto: number = 0;
  totalQuantidade: number = 0;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Código Dealer": "businessIntelligence.consultaVendaAcessorios.codDealer",
    "Nome Dealer": "businessIntelligence.consultaVendaAcessorios.dealerNome",
    "Origem": "businessIntelligence.consultaVendaAcessorios.origem",
    "Número OS": "businessIntelligence.consultaVendaAcessorios.numeroOs",
    "Tipo OS": "businessIntelligence.consultaVendaAcessorios.tipoOs",
    "PartNumber": "businessIntelligence.consultaVendaAcessorios.partnumber",
    "Descrição": "businessIntelligence.consultaVendaAcessorios.descricao",
    "Quantidade": "businessIntelligence.consultaVendaAcessorios.quantidade",
    "Valor Bruto": "businessIntelligence.consultaVendaAcessorios.valorBruto",
    "Valor Desconto": "businessIntelligence.consultaVendaAcessorios.valorDesconto",
    "Valor com Desconto": "businessIntelligence.consultaVendaAcessorios.valorComDesconto",
    "Chassi": "businessIntelligence.consultaVendaAcessorios.chassi",
    "Data Emissão": "businessIntelligence.consultaVendaAcessorios.dataEmissao",
    "Número": "businessIntelligence.consultaVendaAcessorios.numero",
    "CPF/CNPJ": "businessIntelligence.consultaVendaAcessorios.cpfCnpj",
    "Nome Cliente": "businessIntelligence.consultaVendaAcessorios.clienteNome",
    "Email": "businessIntelligence.consultaVendaAcessorios.email",
    "Telefone": "businessIntelligence.consultaVendaAcessorios.telefone",
  }

  constructor(private service: ConsultaVendaAcessoriosService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder,
    private percent: PercentPipe) {
    this.filtros = {};
    this.nomeModulo = 'consulta-venda-acessorios';
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      partnumber: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();

    this.carregando = true;

    this.cols = [
      { field: 'codDealer', header: 'businessIntelligence.consultaVendaAcessorios.codDealer' },
      { field: 'dealerNome', header: 'businessIntelligence.consultaVendaAcessorios.dealerNome' },
      { field: 'origem', header: 'businessIntelligence.consultaVendaAcessorios.origem' },
      { field: 'numeroOs', header: 'businessIntelligence.consultaVendaAcessorios.numeroOs' },
      { field: 'tipoOs', header: 'businessIntelligence.consultaVendaAcessorios.tipoOs' },
      { field: 'partnumber', header: 'businessIntelligence.consultaVendaAcessorios.partnumber' },
      { field: 'descricao', header: 'businessIntelligence.consultaVendaAcessorios.descricao' },
      { field: 'quantidade', header: 'businessIntelligence.consultaVendaAcessorios.quantidade' },
      { field: 'valorBruto', header: 'businessIntelligence.consultaVendaAcessorios.valorBruto' },
      { field: 'valorDesconto', header: 'businessIntelligence.consultaVendaAcessorios.valorDesconto' },
      { field: 'valorComDesconto', header: 'businessIntelligence.consultaVendaAcessorios.valorComDesconto' },
      { field: 'chassi', header: 'businessIntelligence.consultaVendaAcessorios.chassi' },
      { field: 'dataEmissao', header: 'businessIntelligence.consultaVendaAcessorios.dataEmissao' },
      { field: 'numero', header: 'businessIntelligence.consultaVendaAcessorios.numero' },
      { field: 'cpfCnpj', header: 'businessIntelligence.consultaVendaAcessorios.cpfCnpj' },
      { field: 'clienteNome', header: 'businessIntelligence.consultaVendaAcessorios.clienteNome' },
      { field: 'email', header: 'businessIntelligence.consultaVendaAcessorios.email' },
      { field: 'telefone', header: 'businessIntelligence.consultaVendaAcessorios.telefone' }
    ];

    this._selectedColumns = this.cols;

    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.partnumber.value).subscribe(
      (response: ConsultaVendaAcessoriosResponse) => {
        this.dados = response.dados || [];
        this.totalValorBruto = response.totalValorBruto || 0;
        this.totalValorDesconto = response.totalValorDesconto || 0;
        this.totalValorComDesconto = response.totalValorComDesconto || 0;
        this.totalQuantidade = response.totalQuantidade || 0;

        this.orderByDate();

        this.dados.forEach(element => {
          // Formatar valores monetários
          if (element.valorBruto) {
            element.valorBruto = Number(element.valorBruto);
          }
          if (element.valorDesconto) {
            element.valorDesconto = Number(element.valorDesconto);
          }
          if (element.valorComDesconto) {
            element.valorComDesconto = Number(element.valorComDesconto);
          }

          // Formatar número da nota tirando o 0 ao lado do number
          if (element.numero) {
            element.numero = parseInt(element.numero, 10).toString();
          }          

          // Formatar data
          if (element.dataEmissao) {
            element.dataEmissao = element.dataEmissao.substring(0, 10);
          }
        });

        this.carregando = false;
      },
      (error) => {
        this.carregando = false;
        this.dados = [];
      }
    );
  }

  private orderByDate() {
    this.dados.sort((a, b) => {
      let data_a = a.dataEmissao;
      let data_b = b.dataEmissao;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    this.filtros = {};
    this.filtros['data_inicial'] = this.f.data_inicial.value;
    this.filtros['data_final'] = this.f.data_final.value;
    this.filtros['partnumber'] = this.f.partnumber.value;
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.partnumber.value
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  public limparFiltros() {
    this.f.partnumber.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    return this.translate.instant(item);
  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.partnumber.value).subscribe((response: ConsultaVendaAcessoriosResponse) => {
        registros = response.dados;
        this.orderByDate();

        registros.forEach(dados => {
          if (dados.dataEmissao) {
            dados.dataEmissao = dados.dataEmissao.substring(0, 10);
          }

          // Conversão para string para tirar o 0 ao lado do número da nota
            if (dados.numero) {
            dados.numero = parseInt(dados.numero, 10).toString();
          } 
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          this.exportExcelService.colunasFormatacao = [8, 9, 10]; // Valor Bruto, Desconto, Com Desconto
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregando = true;
        this.getAll();
      });
  }

  public ordenarTabela(event: any) {
    this.dados.sort((a, b) => {
      let campo_a = a[event.field];
      let campo_b = b[event.field];

      if (campo_a > campo_b) return -1;
      if (campo_a < campo_b) return 1;

      return 0;
    });
  }

}
